export enum InputType {
  text = 'text',
  password = 'password',
  number = 'number',
  email = 'email'
}

export enum InputScheme {
  normal = 'normal',
  failed = 'failed',
  success = 'success'
}

export enum InputAutocomplete {
  on = 'on',
  off = 'off'
}
